// How old the screen is — TODO T17 (30 Aug 2026); text, not a pill, since T36 (2 Sep 2026).
//
// The brain polls; it does not stream. That is a deliberate architectural choice (CLAUDE.md
// § Brain tier: "polling not sockets", which is what keeps the BFF stateless and out of the
// realtime lane), and this is the one place the choice is visible to the person using it. The
// signed-off conversation-view design asks for exactly this — "'Updated 6s ago' in the top bar
// reflects polling, not sockets".
//
// The glowing pill beside it is kadmon's (Shell.tsx `VeraStatus`), as the mockup draws it; this is
// the plain line under it.
import { useIsFetching, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { formatAgo } from '../format.ts';

export function Freshness() {
  const queryClient = useQueryClient();
  const fetching = useIsFetching();
  const [now, setNow] = useState(() => Date.now());

  // A second hand. Nothing else re-renders this: the number has to keep counting up between
  // polls or it reads as frozen rather than as fresh.
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1_000);
    return () => clearInterval(timer);
  }, []);

  const updatedAt = queryClient
    .getQueryCache()
    .getAll()
    .reduce((latest, query) => Math.max(latest, query.state.dataUpdatedAt), 0);

  return (
    <>
      <span className="micro topbar__fresh">
        {fetching > 0 ? 'Updating…' : `Updated ${formatAgo(updatedAt || null, now)}`}
      </span>
      {/* The signal (T47): a hairline crosses the foot of the top bar once per poll. Keyed on
          the poll's own timestamp, so it remounts — and its animation replays — exactly when a
          poll lands, and the second hand above never touches it. The track is absolute against
          the sticky top bar and clips the run: without it the hairline's last frame sat past the
          right edge and widened the page, which `pnpm console:check` caught on the first render
          (6 Sep 2026). */}
      <span className="topbar__track" aria-hidden>
        {updatedAt > 0 && <span key={updatedAt} className="topbar__sweep" />}
      </span>
    </>
  );
}
